import React from 'react';
import { Link } from 'react-router-dom';

import {
  ChevronRightIcon,
  HeartOutlineIcon,
  LicenseSettingOutlineIcon,
  SimpleTruckOutlineIcon,
} from '@/components/Icon';
import { colors } from '@/const/colors';

export default function ManagementMenus({}) {
  return (
    <div className="px-4">
      <ul>
        {/* <li className="py-5 list-none">
          <Link to={'/products/my'} className="flex items-center cursor-pointer">
            <SimpleTruckOutlineIcon color={colors.gray[7]} width={28} height={28}></SimpleTruckOutlineIcon>
            <p className="flex-1 ml-4 text-lg font-semibold text-gray-8">내차 관리</p>
            <ChevronRightIcon color={colors.gray[5]}></ChevronRightIcon>
          </Link>
        </li> */}
        <li className="py-5 list-none">
          <Link to={'/license/my'} className="flex items-center cursor-pointer">
            <LicenseSettingOutlineIcon color={colors.gray[7]} width={28} height={28}></LicenseSettingOutlineIcon>
            <p className="flex-1 ml-4 text-lg font-semibold text-gray-8">내 번호판 관리</p>
            <ChevronRightIcon color={colors.gray[5]}></ChevronRightIcon>
          </Link>
        </li>
        <li className="py-5 list-none">
          <Link to={'/interest'} className="flex items-center cursor-pointer">
            <HeartOutlineIcon color={colors.gray[7]} width={28} height={28}></HeartOutlineIcon>
            <p className="flex-1 ml-4 text-lg font-semibold text-gray-8">찜한 차량</p>
            <ChevronRightIcon color={colors.gray[5]}></ChevronRightIcon>
          </Link>
        </li>
      </ul>
    </div>
  );
}
